<template>
  <div id="review-summary" v-if="steps">
     <a-steps :current="current" style="margin-bottom: 10px; margin-top: 10px;" size="small">
      <a-step v-for="(item, itemIndex) in steps" :key="item.title" :title="item.title"
        @click="handleStepClick(itemIndex)" />
    </a-steps>
    <a-divider v-if="steps[current]">{{steps[current].subTitle}}</a-divider>
    <a-collapse defaultActiveKey="0" accordion :bordered="true" v-if="steps[current]">
      <a-collapse-panel :header="tab.heading" :key="tabIndex+'_'+current" v-for="(tab, tabIndex) in steps[current].content">
        <a-list :dataSource="tab.questions">
          <a-list-item slot="renderItem" slot-scope="item, questionIndex"
            :key="questionIndex+'_'+tabIndex+'_'+current">
            <a-list-item-meta>
              <h3 slot="title">
                <span>
                  <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
                  {{ (current+1) + '.' + (tabIndex+1) + '.' + (questionIndex+1) + '.' }}
                </span>
                {{item.question}}
              </h3>
              <div slot="description" >
                <span class="admin-answer choosen-answers" v-if="adminReviewerAssessmentData[`question_${current+1}_${tabIndex+1}_${questionIndex+1}`]">
                  Admin Reviewer:
                  <a-tag color=#87d068 style="text-transform: capitalize">{{adminReviewerAssessmentData[`question_${current+1}_${tabIndex+1}_${questionIndex+1}`] | replaceUnderscore}}</a-tag>
                </span>
                <span class="first-reviewer-answer choosen-answers" v-if="firstReviewerAssessmentData[`question_${current+1}_${tabIndex+1}_${questionIndex+1}`]">
                  First Reviewer:
                  <a-tag color=#87d068 style="text-transform: capitalize">{{firstReviewerAssessmentData[`question_${current+1}_${tabIndex+1}_${questionIndex+1}`] | replaceUnderscore}}</a-tag>
                </span>
                <span class="second-reviewer-answer choosen-answers" v-if="secondReviewerAssessmentData[`question_${current+1}_${tabIndex+1}_${questionIndex+1}`]">
                  Second Reviewer:
                  <a-tag color=#87d068 style="text-transform: capitalize">{{secondReviewerAssessmentData[`question_${current+1}_${tabIndex+1}_${questionIndex+1}`] | replaceUnderscore}}</a-tag>
                </span>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <a-divider />
        <div class="domain-assessment" style="text-align: center" v-if="reportStatus === 'completed'">
          <span>
            <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a"  />
          </span>
          Overall:
          <span class="first-reviewer-answer choosen-answers" v-if="getDomainScore(firstReviewerAssessmentData, parseInt(current)+1, tabIndex+1).length > 0">
            First Reviewer:
            <a-tag color=#87d068 style="text-transform: capitalize">{{getDomainScore(firstReviewerAssessmentData, parseInt(current)+1, tabIndex+1) | replaceUnderscore}}</a-tag>
          </span>
          <span class="second-reviewer-answer choosen-answers" v-if="getDomainScore(secondReviewerAssessmentData, parseInt(current)+1, tabIndex+1).length > 0">
            Second Reviewer:
            <a-tag color=#87d068 style="text-transform: capitalize">{{getDomainScore(secondReviewerAssessmentData, parseInt(current)+1, tabIndex+1) | replaceUnderscore}}</a-tag>
          </span>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  name: 'review-summary',
  data() {
    return {
      steps: [],
      customCollapseStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      isLoading: false,
      reportId: 0,
      current: 0,
    };
  },
  computed: {
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapState('assessments', {
      questions: state => state.assessmentQuestions,
    }),
  },
  props: [
    'adminReviewerAssessmentData',
    'firstReviewerAssessmentData',
    'secondReviewerAssessmentData',
    'reportStatus',
  ],
  methods: {
    ...mapActions('assessments', {
      getAssessmentQuestions: 'getAssessmentQuestions',
    }),
    handleStepClick(step) {
      this.current = parseInt(step, 16);
    },
    getDomainScore(reviewData, stepIndex, tabIndex) {
      const domain = this.getDomain(stepIndex);
      return this.steps[(stepIndex - 1)].content[(tabIndex - 1)].domainScore[reviewData[`question_${domain}_${stepIndex}_${tabIndex}`]] ? this.steps[(stepIndex - 1)].content[(tabIndex - 1)].domainScore[reviewData[`question_${domain}_${stepIndex}_${tabIndex}`]] : '';
    },
    getDomain(step) {
      let domain = 1;
      if (step >= 1 && step <= 2) {
        domain = 1;
      } else if (step > 2 && step <= 4) {
        domain = 2;
      } else if (step >= 5 && step <= 6) {
        domain = 3;
      } else if (step >= 7 && step <= 8) {
        domain = 4;
      }
      return domain;
    },
  },
  beforeMount() {
    this.getAssessmentQuestions();
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'assessments/ASSESSMENTQUESTIONSFETCHED') {
        this.steps = this.questions;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
  },
  watch: {
  },
};
</script>
<style scoped>
.choosen-answers {
  margin: 10px;
  color: black;
}
.choosen-answers .ant-tag {
  margin-left: 10px;
}

</style>
<style>
.ant-steps-item-icon {
  width: 20px !important;
  height: 20px !important;
  line-height: 20px !important;
  font-size: 12px !important;
  vertical-align: middle !important;
}
.ant-steps-item-title {
  font-size: 12px !important;
}
.ant-steps-item-content {
  vertical-align: middle !important;
}
.ant-steps-item:hover {
  cursor: pointer;
}
</style>
